export default __webpack_public_path__ + "media/images/btn_edit-5af15248.png";